module.exports = __webpack_public_path__ + "img/emoji-angry.3fda0bba.svg";